enum CommandType {
    SnapshotRequested = 'snapshot-requested',
    SnapshotTaken = 'snapshot-taken',
    SnapshotUploaded ='snapshot-uploaded',
    LaserPointer = 'laser-pointer',
    Backgrounded = 'backgrounded',
    VisitorRejected = 'visitor-rejected',
    Unbackgrounded = 'unbackgrounded',
    Ping = 'ping',
    ScreenshareStarted = 'screenshare-started',
}
type CommandPayload = {
	senderId: string;
    senderName: string;
    id: string;
    timestamp: number;
	commandType: CommandType;
}
export type { CommandPayload };
export { CommandType };